import { useState, useEffect, useMemo, useRef } from "react";
import { getDeviceImage } from "../utils/UtilityFuncs";
import { useSelector, useDispatch } from "react-redux";
import { Badge, Form } from "react-bootstrap";
import './../utils/autocomplete.scss';
import useClickOutside from "../../hooks/useClickOutside"
import useDevicesData from "../../hooks/useDevicesData";

const TagSelector = ({ tags, selectedTags, setSelectedTags, split = false }) => {

  if (!tags) {
    return null;
  }

  selectedTags = selectedTags || [];
  // function to handle the tag click
  const handleTagClick = (clickedTag) => {
    if (selectedTags.some(tag => tag.slug === clickedTag.slug)) {
      // If clicked tag is already selected, remove it from selectedTags
      setSelectedTags(selectedTags.filter(tag => tag.slug !== clickedTag.slug));
    } else {
      // Otherwise add the clicked tag to selectedTags
      setSelectedTags([...selectedTags, clickedTag]);
    }
  };
  const clearTags = () => {
    setSelectedTags([]);
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          {(selectedTags && selectedTags instanceof Array && selectedTags.length > 0)
            ?
            <>
              <i className={`fa-solid fa-tags gold`} />
              <div
                style={{ display: 'flex', flexWrap: 'wrap', width: 'max-content', maxWidth: '250px', margin: '0 1em 0 1em', fontSize: '12px' }}
              >
                {tags.filter(tag => selectedTags.map(t => t.slug).includes(tag.slug)).map((tag, i) =>
                  <Badge
                    key={i}
                    className="tag"
                    style={{ fontSize: '0.8em', margin: '0.2em', cursor: 'pointer', color: 'white', backgroundColor: 'rgb(0, 123, 255)' }}
                  >{tag.name}</Badge>
                )}
              </div>
            </>
            :
            <>
              <i className={`fa-solid fa-tags`} />
              <span style={{ margin: '0  0 0 1em' }}>Select Tag(s)</span>
            </>}
        </div>
        <div>
          <i className="fa-solid fa-rotate" onClick={clearTags} style={{ cursor: 'pointer', marginRight: '10px' }} />
        </div>
      </div>
      <div style={{
        background: 'rgb(36, 41, 53)',
        padding: '10px',
        display: 'flex',
        flexWrap: 'wrap',
        maxHeight: '20em',
        overflowY: 'auto',
        position: 'relative'
      }}>
        {!split ? <>
          {tags.sort((a, b) => a.name.localeCompare(b.name)).map(tag => {
            const isSelected = selectedTags.some(selectedTag => selectedTag.slug === tag.slug);
            return (
              <Badge
                key={tag.slug}
                className="tag"
                style={{ fontSize: '0.8em', margin: '0.2em', cursor: 'pointer', color: 'white', backgroundColor: isSelected ? 'rgb(0, 123, 255)' : 'grey' }}
                onClick={() => handleTagClick(tag)}
              >
                {tag.name}
              </Badge>
            )
          })}
        </> : <>
          <fieldset style={{ backgroundColor: 'rgb(42, 48, 62)', padding: '4px' }}>
            <legend style={{ fontSize: '12px' }}>status</legend>
            {tags.filter(f => f.type === 'status').sort((a, b) => a.name.localeCompare(b.name)).map(tag => {
              const isSelected = selectedTags.some(selectedTag => selectedTag.slug === tag.slug);
              return (
                <Badge
                  key={tag.slug}
                  className="tag"
                  style={{ fontSize: '0.8em', margin: '0.2em', cursor: 'pointer', color: 'white', backgroundColor: isSelected ? 'rgb(0, 123, 255)' : 'grey' }}
                  onClick={() => handleTagClick(tag)}
                >
                  {tag.name}
                </Badge>
              )
            })}
          </fieldset>
          <div style={{ marginTop: '10px' }}>
            {tags.filter(f => f.type === 'device').sort((a, b) => a.name.localeCompare(b.name)).map(tag => {
              const isSelected = selectedTags.some(selectedTag => selectedTag.slug === tag.slug);
              return (
                <Badge
                  key={tag.slug}
                  className="tag"
                  style={{ fontSize: '0.8em', margin: '0.2em', cursor: 'pointer', color: 'white', backgroundColor: isSelected ? 'rgb(0, 123, 255)' : 'grey' }}
                  onClick={() => handleTagClick(tag)}
                >
                  {tag.name}
                </Badge>
              )
            })}
          </div>
        </>}

      </div>
    </div>
  );
};

const SearchBar = ({ open, setOpen }) => {
  const dispatch = useDispatch();
  const { devices, tags } = useDevicesData();
  const { selectedDevice, deviceId, tagFilters, showDevice, filteredDevices, tagSearch } = useSelector(state => ({
    selectedDevice: state.main.selectedDevice,
    deviceId: state.main.deviceId,
    tagFilters: state.main.tagFilters,
    showDevice: state.main.showDevice,
    filteredDevices: state.main.filteredDevices,
    tagSearch: state.main.tagSearch
  }));
  const setSelectedDevice = (selectedDevice) => dispatch({ type: "SELECTED_DEVICE", selectedDevice });
  const saveDeviceId = (deviceId) => dispatch({ type: "DEVICE_ID", deviceId });
  const setTagFilters = (tagFilters) => dispatch({ type: "TAG_FILTERS", tagFilters });
  const setTagSearch = (tagSearch) => dispatch({ type: "TAG_SEARCH", tagSearch })
  const setFilteredDevices = (filteredDevices) => dispatch({ type: "FILTERED_DEVICES", filteredDevices });
  const ref = useRef();

  useClickOutside(ref, () => {
    if (open)
      setOpen(false);
  });

  // Manages filteredDevices list, from devices, filtering from tagFilters and then tagSearch.
  useEffect(() => {
    if (devices) {
      let filtered = devices;
      if (tagFilters && tagFilters instanceof Array && tagFilters.length > 0) {
        filtered = filtered.filter(device => tagFilters.every(t => device.tags.some(tag => t.name === tag.name)));
      }
      if (tagSearch) {
        filtered = filtered.filter(device => device.label.toLowerCase().includes(tagSearch.toLowerCase()) || device.ip_address.includes(tagSearch) || device.tags.some(t => t.name?.toLowerCase().includes(tagSearch.toLowerCase())));
      }
      setFilteredDevices((devices.length > filtered.length) ? filtered.sort((a, b) => a.label.localeCompare(b.label)) : null);
    }
  }, [tagSearch, tagFilters, devices]);

  // Loads tags from local storage if we don't have any.  Validates against tags.
  useEffect(() => {
    if (!tagFilters && tags) {
      let tagFiltersFromLocalStorage;
      try {
        tagFiltersFromLocalStorage = JSON.parse(localStorage.getItem('tagFilters'));
      } catch (e) {
        console.error('Error reading tagFilters from localStorage', e);
      }
      if (tagFiltersFromLocalStorage) {
        // Filter out tag filters that are not present in any device
        const validTagFilters = tagFiltersFromLocalStorage.filter(filter =>
          tags.some(tag => tag => tag.name === filter.name)
        );
        setTagFilters(validTagFilters)
      }
    }
  }, [tagFilters, tags]);


  useEffect(() => {

    if (deviceId && selectedDevice && 'id' in selectedDevice && parseInt(deviceId) === selectedDevice.id) {
      // deviceId exists and matches selectedDevice.id, doing nothing.
      return;

    } else if (deviceId && devices) {
      // deviceId exists but doesn't match selectedDevice, or selectedDevice is undefined, trying to find the corresponding device from devices
      let selDev = devices.find(f => f.id == parseInt(deviceId));
      if (selDev) {
        // Device found in the devices array, setting selectedDevice
        setSelectedDevice(selDev);
      } else {
        // Couldn't find the device in devices, removing deviceId from localStorage and setting deviceId and selectedDevice to null
        try {
          localStorage.removeItem('deviceId');
        } catch (e) {
          console.error('Error removing deviceId from localStorage', e);
        }
        saveDeviceId(null);
        setSelectedDevice(null);
      }

    } else {
      // deviceId doesn't exist, trying to get it from localStorage and find the corresponding device from devices
      let deviceIdFromLocalStorage;
      try {
        deviceIdFromLocalStorage = localStorage.getItem('deviceId');
        console.log("deviceId from localStorage:", deviceIdFromLocalStorage);
      } catch (e) {
        console.error('Error reading deviceId from localStorage', e);
      }

      if (deviceIdFromLocalStorage && devices) {
        let selDev = devices.find(f => f.id == parseInt(deviceIdFromLocalStorage));
        if (selDev) {
          // Found device, set selected and deviceId
          setSelectedDevice(selDev);
          saveDeviceId(deviceIdFromLocalStorage);
        } else {
          // Couldn't find the device in devices, removing deviceId from localStorage and setting deviceId and selectedDevice to null.
          try {
            localStorage.removeItem('deviceId');
          } catch (e) {
            console.error('Error removing deviceId from localStorage', e);
          }
          saveDeviceId(null);
          setSelectedDevice(null);
        }
      }
    }
  }, [deviceId, selectedDevice, devices]);


  const clearInput = () => {
    setTagSearch(null);
  };

  const onChange = (e) => {
    setTagSearch(e.target.value);
  };

  const renderDevice = (x, index) => {
    const className = deviceId === x.id ? "activeClass" : "searchbox-card";
    return (
      <div className={className} key={index} style={className === "activeClass"
        ? { borderRadius: "0.4rem", background: "#0066ff1a", display: 'flex', padding: '10px', flexDirection: 'column' }
        : { display: 'flex', flexDirection: 'column', padding: '10px' }}
        onClick={(e) => {
          if (e.ctrlKey) {
            // Open a new tab with the URL you want when Ctrl+click
            window.open(`/devices/${x.id}`, '_blank');
          } else {
            // Change the deviceId state when left click
            saveDeviceId(x.id);
          }
        }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img style={{ width: "40px", marginRight: '1em' }} src={getDeviceImage(x.profile)} alt="Device Logo" />
          <div className="media-body">
            <div className="chat-header f-w-400 mb-1">
              {x.label.length <= 25 ? x.label : x.label.substr(0, 25) + '\u2026'}
            </div>
            <p className="chat-header  text-muted" style={{ marginBottom: '0' }}>
              {x.ip_address}
            </p>
          </div>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', maxWidth: '100%', marginTop: '1em', justifyContent: 'flex-start' }}>
          {x.tags.filter((t) => t.type === "device").map((tag, i) => <Badge style={{ margin: '0.1em', fontSize: '10px' }} variant="primary" key={`s${i}`}>{tag.name}</Badge>)}
        </div>
      </div>
    );
  }


  const renderDevices = useMemo(() => {
    let sortedDevices = filteredDevices || devices || [];
    if (sortedDevices.length == 0) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <i style={{ width: "40px", marginRight: '1em' }} className="fa-solid fa-question fa-2xl" />
            <div className="media-body">
              <div className="chat-header f-w-400 mb-1">
                No Results
              </div>
            </div>
          </div>
        </div>
      )
    }
    sortedDevices.sort((a, b) => a.label.localeCompare(b.label));
    return sortedDevices.map((x, index) => {
      return (
        renderDevice(x, index)
      );
    });
  }, [filteredDevices, devices, selectedDevice]);
  let showSearch = true;

  return (
    <div ref={ref}
      style={{
        position: 'relative',
        width: '400px',
        marginLeft: '30px'
      }}>
      {open &&
        <>
          <div
            id="searchbar"
            className="slide-in"
            style={{
              display: 'flex',
              flexDirection: 'column',
              zIndex: '1',
              width: '400px',
              background: 'rgb(36, 43, 58)',
              position: 'fixed',
              top: '4em',
              bottom: (showDevice) ? '5em' : undefined,
            }}>
            <div style={{ padding: '15px', paddingBottom: '0.5em' }}>
              <TagSelector tags={tags} selectedTags={tagFilters} setSelectedTags={setTagFilters} />
            </div>
            {(showDevice || showSearch) && <>
              <div id="main-search" className="main-search open" style={{ display: 'flex', justifyContent: 'center', width: '100%', paddingBottom: '1em' }}>
                <div className="input-group" style={{ width: '90%', padding: '1px 1px 1px 20px' }}>
                  <Form.Control id="m-search" className="nm-form-input" type="text" name="name" placeholder="Search . . ." value={tagSearch || ""} onChange={onChange} />
                  {tagSearch && <span onClick={clearInput} style={{ display: 'flex', alignItems: 'center' }}><i className="fa-solid fa-x fa-lg" /></span>}
                  <span className="search-btn btn btn-primary">
                    <i className="fa-solid fa-magnifying-glass fa-lg" style={{ margin: '5px' }} />
                  </span>
                </div>
              </div>
              {showDevice && <>
                <div style={{
                  flex: '1 1 auto',
                  padding: '10px',
                  paddingTop: '0px',
                  overflowY: 'auto'
                }}>
                  {renderDevices}
                </div>
              </>}

            </>
            }

          </div>

        </>
      }
    </div>
  )
}

export default SearchBar;


